import { HexColorPicker } from 'react-colorful';
import { useState } from 'react';

interface UtmColorPickerProps {
  color: string;
  onChange: (color: string) => void;
  label?: string;
}

const UtmColorPicker = ({ color, onChange, label }: UtmColorPickerProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="space-y-2">
      {label && <label className="text-sm font-medium text-foreground">{label}</label>}
      <div className="relative">
        <button
          type="button"
          onClick={() => setIsOpen(!isOpen)}
          className="flex items-center space-x-3 px-4 py-2 bg-muted border border-border rounded-lg hover:bg-accent transition-colors w-full"
        >
          <div
            className="w-8 h-8 rounded border border-border"
            style={{ backgroundColor: color }}
          />
          <span className="text-sm text-foreground font-mono">{color}</span>
        </button>

        {isOpen && (
          <>
            <div className="fixed inset-0 z-10" onClick={() => setIsOpen(false)} />
            <div className="absolute z-20 mt-2 p-3 bg-muted border border-border rounded-lg shadow-xl">
              <HexColorPicker color={color} onChange={onChange} />
              <input
                type="text"
                value={color}
                onChange={(e) => onChange(e.target.value)}
                className="mt-3 w-full px-3 py-2 bg-card border border-border rounded text-sm text-foreground font-mono"
                placeholder="#000000"
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default UtmColorPicker;
